<div class="pop_up" *ngIf="exists" [class.active]="display">
    <div class="overlay" (click)="closePoUp()"></div>
    <div class="pop_up_content">
        <img src="assets/svg/close_pop_up.svg" alt="Close Pop up" class="close_pop_up" (click)="closePoUp()">
        <app-upload-files *ngIf="popUp == 1"></app-upload-files>
    </div>
</div>